// actions/index.js
import { LOGIN, USER_LOGOUT, USER_ROLE } from './types';
import userManagement from '../../POS/services/userManagement';

export const saveLogin = (data) => ({ type: LOGIN, payload: data });

export const logout = () => ({ type: USER_LOGOUT });

// Simplified setUserRole
export const setUserRole = (role) => ({
  type: USER_ROLE,
  payload: role,
});
